module.exports = __webpack_public_path__ + "img/edit-icon.26e55e8c.svg";